/**
 * Origin of the VIO host that embeds this app: the `parentOrigin` URL param the
 * Member App sets, else the referrer. null when opened on its own.
 */
export function getParentOrigin(search = window.location.search, referrer = document.referrer) {
  try {
    const raw = new URLSearchParams(search).get("parentOrigin") || referrer;
    return raw ? new URL(raw).origin : null;
  } catch {
    return null;
  }
}

export function isEmbedded() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
